import { Intent } from '../../@types/intent'
import { RealEstateType } from '../../@types/realEstateType'
import { CommercialRealEstateType } from '../../@types/commercialRealEstateType'

export const redirect = (
  intent: Intent,
  realEstateType?: RealEstateType,
  commercialRealEstateType?: CommercialRealEstateType
) => {
  if (intent == Intent.INDEPENDENT_SALE) {
    switch (realEstateType) {
      case RealEstateType.HOUSE:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/haus/?cmp_id=10-052051&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
        )
        break
      case RealEstateType.APARTMENT:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/wohnung/?cmp_id=10-052052&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
        )
        break
      case RealEstateType.LAND:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/grundstueck/?cmp_id=10-052053&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
        )
        break
      case RealEstateType.COMMERCIAL:
        switch (commercialRealEstateType) {
          case CommercialRealEstateType.OFFICE:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/buero/?cmp_id=10-052054&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.GASTRONOMY:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/gastronomie/?cmp_id=10-052055&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.RETAIL:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/einzelhandel/?cmp_id=10-052056&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.HALL:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/halle/?cmp_id=10-052057&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.MISCELLANEOUS:
            window.open(
              'https://www.immobilienscout24.de/scoutmanager/inserieren/app/index.html?cmp_id=10-052098&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
        }
    }
  } else if (intent == Intent.BUY) {
    window.open(
      'https://www.immobilienscout24.de/baufinanzierung/finanzierungsangebote/?cmp_id=10-051998&cmp_name=finance_realtorleadengine_ibw&cmp_position=buy_successpage_ibw&cmp_creative=button'
    )
  } else if (intent == Intent.RENT) {
    window.open(
      'https://www.immobilienscout24.de/warenkorb/mieterplus?cmp_id=10-051999&cmp_name=premium_profil_rent&cmp_position=rent_successpage_ibw&cmp_creative=button_checkout'
    )
  } else if (intent == Intent.LET || intent == Intent.INDEPENDENT_LET) {
    switch (realEstateType) {
      case RealEstateType.HOUSE:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/haus/?cmp_id=10-052058&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
        )
        break
      case RealEstateType.APARTMENT:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/wohnung/?cmp_id=10-052059&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
        )
        break
      case RealEstateType.COMMERCIAL:
        switch (commercialRealEstateType) {
          case CommercialRealEstateType.OFFICE:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/buero/?cmp_id=10-052060&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.GASTRONOMY:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/gastronomie/?cmp_id=10-052061&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.RETAIL:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/einzelhandel/?cmp_id=10-052062&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.HALL:
            window.open(
              'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/halle/?cmp_id=10-052063&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
            break
          case CommercialRealEstateType.MISCELLANEOUS:
            window.open(
              'https://www.immobilienscout24.de/scoutmanager/inserieren/app/index.html?cmp_id=10-052098&cmp_name=homeowner_ppa&cmp_position=homeowner_realtorleadengine&cmp_creative=ppa_integration'
            )
        }
    }
  }
}
